import styles from './UpdateBanner.module.scss'

interface UpdateBannerProps {
  visible: boolean
}

export const UpdateBanner = ({ visible }: UpdateBannerProps) => {
  if (!visible) return null

  return (
    <div className={styles.banner}>
      <span className={styles.message}>A new version is available</span>
      <button
        className={styles.button}
        onClick={() => window.location.reload()}
      >
        Refresh
      </button>
    </div>
  )
}
